import { Toaster as Sonner, toast } from 'sonner';

/** Notifications for the result of an action; styled with the design tokens. */
export function Toaster({ theme }: { theme: 'light' | 'dark' }) {
  return (
    <Sonner
      theme={theme}
      position="bottom-right"
      toastOptions={{
        classNames: {
          toast: 'rounded-lg border border-line-subtle bg-surface text-fg-1 shadow-md font-sans',
          description: 'text-fg-2',
          error: 'border-danger/50',
          success: 'border-success/50',
        },
      }}
    />
  );
}

export { toast };
